<template>
    <div :style="choose" v-if="choose == ''" class="choose-option">
        <span class="arrow">↑</span>
        <h4> Wybierz profil </h4>
    </div>
    <div :style="choose" v-else-if="choose != ''"  class="options-preview">
        <h4> {{name}}  </h4>
        <Selects @denisty="getDenisty" />
        <Inputs @parameters="collectParametrs" :profile="choose" :g="gestosc"/>
        <Result
          :profile="choose"
          :g="gestosc"
          :height="height"
          :outerDiameter="outerDiameter"
          :size="size"
          :width="width"
          :innerDiameter="innerDiameter"
          :wallSize="wallSize"
          :lenght="lenght"
        />
        <Preview :img="name"/>
    </div>
</template>

<script>
import Selects from '@/components/Selects.vue';
import Inputs from '@/components/Inputs.vue';
import Preview from '@/components/Preview.vue';
import Result from '@/components/Result.vue';

export default {
  name: 'Output',
  components: {
    Selects,
    Inputs,
    Preview,
    Result,
  },
  props: ['choose', 'name', 'denisty'],
  data() {
    return {
      profile: '',
      imgName: '',
      gestosc: '',
      height: 0,
      outerDiameter: 0,
      size: 0,
      width: 0,
      innerDiameter: 0,
      wallSize: 0,
      lenght: 1000,
    };
  },
  methods: {
    getDenisty(den) {
      this.gestosc = den;
    },
    collectParametrs(height, outerDiameter, size, width, innerDiameter, wallSize, lenght) {
      this.height = height;
      this.outerDiameter = outerDiameter;
      this.size = size;
      this.width = width;
      this.innerDiameter = innerDiameter;
      this.wallSize = wallSize;
      this.lenght = lenght;
    },
  },
};
</script>

<style scoped>
  .choose-option{
    display:flex;
    justify-content: center;
    min-height: 300px;
    align-items: center;
  }
  .choose-option h4{
    font-size: 24px;
    letter-spacing: 1px;
    line-height: 36px;
  }
  .options-preview {
    max-width: 335px;
    margin: 0 auto;
  }
  .options-preview h4{
    margin: 5px 0;
    letter-spacing: 1px;
    text-align: center;
    font-size: 1.2rem;
    text-transform: uppercase;
    color: #fd5f00;
  }
  .arrow{
    font-size: 64px;
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translateX(-50%);
    color: #fd5f00;
  }
  @media (max-width: 400px){
    .options-preview{
      padding:0 15px;
    }
  }
</style>
